import React from 'react';
import PropTypes from 'prop-types';
import Conversations from "./Conversations";
import {compose, graphql} from 'react-apollo';
import {requireLoggedUser} from "helpers/login";
import {graphQLErrorProcesor} from "helpers/errors";
import {withOperator} from 'helpers/operator';
import QueryString from "query-string";
import {generateUrl, routes} from "helpers/routes";
import {setActiveConversation} from "actions/activeConversation";
import {connect} from "react-redux";

import ChangeOnlineMutation from 'gql/operator/changeOnline.gql';
import ContactsQuery from 'gql/contactList.gql';
import CustomerQuery from 'gql/customer/customer.gql';
import SetNoteMutation from 'gql/contact/setVoiceNote.gql';
import SendSMSMutation from 'gql/contact/sendSms.gql';
import EditProfileNote from 'gql/profile/editNote.gql';
import CreateProfileNote from 'gql/profile/createNote.gql';
import EditProfileTitle from 'gql/profile/editTitle.gql';
import EditProfileInfo from 'gql/profile/editInfo.gql';
import MarkProfileRead from 'gql/profile/markRead.gql';
import EnumsQuery from 'gql/advert/enums.gql';
import AdvertEditMutation from 'gql/advert/edit.gql';
import AdvertCreateMutation from 'gql/advert/create.gql';
import OperatorQuery from 'gql/operator/operator.gql';
import ProfileList from 'gql/profile/list.gql';
import ContactList from 'gql/contact/list.gql';
import {toggleModal} from "../../actions/modal";

class ConversationsProvider extends React.Component {
    static propTypes = {
        user: PropTypes.object.isRequired,
        operator: PropTypes.object.isRequired,
        onLogout: PropTypes.func.isRequired,
        onOnlineChange: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        contactsQuery: PropTypes.object,
        customerQuery: PropTypes.object,
        setVoiceNote: PropTypes.func.isRequired,
        sendSms: PropTypes.func.isRequired,
        editProfileNote: PropTypes.func.isRequired,
        createProfileNote: PropTypes.func.isRequired,
        editProfileInfo: PropTypes.func.isRequired,
        editProfileTitle: PropTypes.func.isRequired,
        markProfileRead: PropTypes.func.isRequired,
        enumsQuery: PropTypes.object.isRequired,
        editAdvert: PropTypes.func.isRequired,
        createAdvert: PropTypes.func.isRequired,
        defaultProfile: PropTypes.number,
        setDefaultProfile: PropTypes.func.isRequired,
        firstAdvertCreatedModalOpened: PropTypes.bool,
        toggleFirstAdvertCreatedModal: PropTypes.func.isRequired,
    };

    componentWillMount() {
        this.setState({
            advert: null,
            contactFilter: null,
        });
    }

    componentDidMount() {
        this.updateView();
        window.addEventListener('resize', ::this.updateView);
    }

    componentDidUpdate() {
        this.updateView();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', ::this.updateView);
    }

    getView() {
        const query = QueryString.parse(this.props.location.search);
        return query['view'];
    }

    updateView() {
        const width = window.innerWidth;
        const view = this.getView();
        if (!view && width < 768) {
            this.changeView('controls');
        }
        else if (view && width >= 768) {
            this.changeView(undefined);
        }
    }

    changeView(newView) {
        const location = Object.assign({}, this.props.location);
        const query = QueryString.parse(location.search);
        query['view'] = newView;
        location.search = QueryString.stringify(query);

        this.props.history.replace(location);
    }

    changeOnline(online) {
        return this.props.changeOnline({
            variables: {
                operator: this.props.user.id,
                online
            }
        });
    }

    createAdvert(model) {
        return this.props.createAdvert({
            variables: {
                advert: {
                    operatorId: this.props.user.id,
                    nickname: model.name,
                    heading: model.title,
                    text: model.text,
                    priceLevelVoiceId: model.callPrice,
                    priceLevelTextId: model.smsPrice,
                    photo: model.photoUrl,
                    serviceTypes: model.serviceTypes,
                    adHappyHours: model.happyHours,
                }
            },
            update: (store, {data: {advert}}) => {
                const query = ContactsQuery;
                const variables = {
                    operator: this.props.operatorQuery.operator ? this.props.operatorQuery.operator.id : null,
                    contactOffset: 0,
                    contactLimit: 1,
                    profileLimit: 10,
                    profileOffset: 0
                };

                const data = store.readQuery({query, variables});
                data.adverts.push(Object.assign({profiles: [], numUnreadProfiles: 0, numProfiles: 0}, advert));
                store.writeQuery({query, variables, data});

                const operatorData = store.readQuery({query: OperatorQuery});
                operatorData.operator.publicNumbers.countAssigned++;
                store.writeQuery({query: OperatorQuery, data: operatorData});
            }
        });
    }

    editAdvert(advert, model) {
        return this.props.editAdvert({
            variables: {
                advert: {
                    id: advert,
                    nickname: model.name,
                    heading: model.title,
                    text: model.text,
                    priceLevelVoiceId: model.callPrice,
                    priceLevelTextId: model.smsPrice,
                    photo: /^http.*/.test(model.photoUrl) ? null : model.photoUrl,
                    serviceTypes: model.serviceTypes,
                    adHappyHours: model.happyHours,
                }
            }
        });
    }

    setVoiceNote(contact, note) {
        return this.props.setVoiceNote({
            variables: {
                contact,
                note
            }
        });
    }

    sendSms(profile, message) {
        return this.props.sendSms({
            variables: {
                profile,
                message
            }
        });
    }

    changeFilter(filter) {
        this.setState({
            contactFilter: filter
        });
        return this.props.customerQuery.refetch({
            contactType: filter,
        });
    }

    changeAdvert(advertId) {
        const location = {
            search: this.props.location.search,
            hash: 'advert=' + advertId,
            pathname: this.props.location.pathname,
        };
        this.props.history.replace(location);
    }

    toggleFavouriteProfileNote(note) {
        return this.props.editProfileNote({
            variables: {
                note: note.id,
                data: {
                    favourite: !note.favourite
                }
            }
        });
    }

    createProfileNote(profile, text) {
        const profileId = profile;
        return this.props.createProfileNote({
            variables: {
                profile: profile,
                data: {
                    note: text
                }
            },
            update: (proxy, {data: {customerProfileCreateNote}}) => {
                const query = CustomerQuery;
                const variables = {
                    customer: parseInt(this.props.match.params.customer, 10),
                    contactOffset: 0,
                    contactLimit: 50
                };

                const data = proxy.readQuery({query, variables});
                const profile = data.customer.profiles.find(prof => (prof.id === profileId));
                profile.notes.push(customerProfileCreateNote);

                proxy.writeQuery({query, variables, data});
            }
        });
    }

    editProfileNote(id, text) {
        return this.props.editProfileNote({
            variables: {
                note: id,
                data: {
                    note: text
                }
            }
        });
    }

    markProfileRead(profile) {
        return this.props.markProfileRead({
            variables: {
                profile
            }
        });
    }

    changeProfileTitle(profile, title) {
        return this.props.editProfileTitle({
            variables: {
                profile,
                title
            }
        });
    }

    changeProfileInfo(profile, info) {
        return this.props.editProfileInfo({
            variables: {
                profile,
                info
            }
        });
    }

    changeProfileFilter(title) {
        return this.props.contactsQuery.refetch({
            profileTitle: title,
        });
    }

    componentWillReceiveProps(props) {
        const {contactsQuery, customerQuery, match, history, defaultProfile, setDefaultProfile} = props;
        const adverts = (contactsQuery && contactsQuery.adverts && contactsQuery.adverts.length > 0) ? contactsQuery.adverts : [];

        const advertId = parseInt(match.params.advert, 10);
        const selectedAdvert = advertId ? adverts.find(advert => (advert.id === advertId)) : null;

        if (adverts.length > 0 && !selectedAdvert) {
            history.push(generateUrl(routes.conversations, {advert: adverts[0].id}));
            return;
        }

        const customerProfiles = (customerQuery && customerQuery.customer) ? customerQuery.customer.profiles : [];
        const profile = match.params.profile ? customerProfiles.find(profile => (parseInt(match.params.profile, 10) === profile.id)) : null;

        if (!customerQuery && selectedAdvert) {
            if (defaultProfile) {
                const redirectionProfile = selectedAdvert.profiles.find(profile => defaultProfile === profile.id);
                if (redirectionProfile) {
                    history.push(generateUrl(routes.conversations, {
                        advert: advertId,
                        customer: redirectionProfile.customer.id,
                        profile: redirectionProfile.id,
                    }));
                }
                return;
            }
            else if (selectedAdvert.profiles.length > 0) {
                setDefaultProfile(selectedAdvert.id, selectedAdvert.profiles[0].id);
            }
        }

        if (profile) {
            setDefaultProfile(profile.advert.id, profile.id);
        }
    }

    render() {
        const {
            operator,
            onLogout,
            onOnlineChange,
            contactsQuery,
            customerQuery,
            match,
            enumsQuery,
            toggleFirstAdvertCreatedModal,
            firstAdvertCreatedModalOpened,
        } = this.props;

        const adverts = (contactsQuery && contactsQuery.adverts && contactsQuery.adverts.length > 0) ? contactsQuery.adverts : [];

        const advertId = parseInt(match.params.advert, 10);
        const selectedAdvert = advertId ? adverts.find(advert => (advert.id === advertId)) : null;

        const customerProfiles = (customerQuery && !customerQuery.loading && customerQuery.customer) ? customerQuery.customer.profiles : [];
        const profile = match.params.profile ? customerProfiles.find(profile => (parseInt(match.params.profile, 10) === profile.id)) : null;

        let contacts = [], notes = [];
        if (profile && profile !== -1) {
            notes = profile.notes;
            contacts = profile.contacts.slice(0);
        }
        else if (customerProfiles.length > 0) {
            notes = customerProfiles.reduce((result, profile) => {
                return result.concat(profile.notes);
            }, []).sort((a, b) => (a.favourite ? (b.favourite ? 0 : -1) : (b.favourite ? 1 : 0)));
            contacts = customerProfiles.reduce((result, profile) => {
                return result.concat(profile.contacts);
            }, []);
        }

        contacts = contacts.reverse();

        const serviceTypes = (enumsQuery && enumsQuery.serviceTypes)
            ? enumsQuery.serviceTypes.map(type => ({name: type.name, value: type.key}))
            : [];
        const priceLevelsVoice = (enumsQuery && enumsQuery.availablePriceLevelsVoice)
            ? enumsQuery.availablePriceLevelsVoice.map(level => ({name: level.description, value: level.id.toString(10)}))
            : [];
        const priceLevelsSms = (enumsQuery && enumsQuery.availablePriceLevelsSms)
            ? enumsQuery.availablePriceLevelsSms.map(level => ({name: level.description, value: level.id.toString(10)}))
            : [];

        return (
            <Conversations onAdvertChange={::this.changeAdvert} adverts={adverts} onSaveVoiceNote={::this.setVoiceNote}
                           selectedAdvert={selectedAdvert !== -1 ? selectedAdvert : null}
                           operator={operator} onLogout={onLogout} onOnlineChange={onOnlineChange}
                           contacts={contacts} profileList={customerProfiles} profile={profile}
                           contactFilter={this.state.contactFilter} onSendSms={::this.sendSms}
                           onContactFilterChange={::this.changeFilter} notes={notes}
                           onProfileTitleSearchChange={::this.changeProfileFilter}
                           onProfileNoteFavoutriteToggle={::this.toggleFavouriteProfileNote}
                           onProfileNoteCreate={::this.createProfileNote} onProfileInfoChange={::this.changeProfileInfo}
                           onProfileTitleChange={::this.changeProfileTitle} serviceTypeValues={serviceTypes}
                           onProfileConversationRead={::this.markProfileRead} priceValuesVoice={priceLevelsVoice} priceValuesSms={priceLevelsSms}
                           onAdvertEdit={::this.editAdvert} onAdvertCreate={::this.createAdvert}
                           onProfileNoteEdit={::this.editProfileNote}
                           canCreateAdvert={operator.publicNumbers.countAssigned < operator.publicNumbers.countMax}
                           onLoadMoreProfiles={contactsQuery.loadMoreProfiles}
                           onLoadMoreContacts={customerQuery ? customerQuery.loadMoreContacts : () => {
                           }}
                           view={this.getView()} changeView={::this.changeView}
                           toggleFirstAdvertCreatedModal={toggleFirstAdvertCreatedModal}
                           firstAdvertCreatedModalOpened={firstAdvertCreatedModalOpened}
            />
        )
    }
}

export default compose(
    requireLoggedUser,
    withOperator,
    connect(
        (state, ownProps) => ({
            defaultProfile: ownProps.match.params.advert ? state.activeConversation[ownProps.match.params.advert] : null,
            firstAdvertCreatedModalOpened: state.modal.firstAdvertCreated.open,
        }),
        (dispatch) => ({
            setDefaultProfile: (advert, profile) => dispatch(setActiveConversation(advert, profile)),
            toggleFirstAdvertCreatedModal: () => dispatch(toggleModal('firstAdvertCreated')),
        }),
    ),
    graphql(EnumsQuery, {
        name: 'enumsQuery',
        options: {
            fetchPolicy: 'cache-first',
        }
    }),
    graphql(ContactsQuery, {
        name: 'contactsQuery',
        options: props => ({
            skip: !props.operator,
            variables: {
                operator: props.operator ? parseInt(props.operator.id, 10) : null,
                contactLimit: 1,
                contactOffset: 0,
                profileLimit: 10,
                profileOffset: 0,
            },
            fetchPolicy: 'cache-first',
        }),
        props({contactsQuery: {fetchMore, adverts, variables, ...rest}}) {
            return {
                contactsQuery: {
                    adverts,
                    variables,
                    ...rest,
                    loadMoreProfiles(advert) {
                        return fetchMore({
                            query: ProfileList,
                            variables: {
                                advert,
                                contactType: variables.contactType,
                                contactOffset: variables.contactOffset,
                                contactLimit: variables.contactLimit,
                                offset: adverts.find(a => (a.id === advert)).profiles.length,
                                limit: variables.profileLimit,
                            },
                            updateQuery: (previousResult, {fetchMoreResult}) => {
                                if (!fetchMoreResult.ad || !fetchMoreResult.ad.customerProfiles) {
                                    return previousResult;
                                }
                                const adverts = previousResult.adverts.slice(0);
                                const advertIdx = adverts.findIndex(a => (a.id === advert));
                                const profiles = [...adverts[advertIdx].profiles, ...fetchMoreResult.ad.customerProfiles];
                                adverts[advertIdx] = Object.assign({}, adverts[advertIdx], {profiles});
                                return Object.assign({}, previousResult, {adverts});
                            }
                        });
                    }
                }
            }
        }
    }),
    graphql(CustomerQuery, {
        name: 'customerQuery',
        options: props => ({
            skip: !/^\d+$/.test(props.match.params.customer),
            variables: {
                customer: parseInt(props.match.params.customer, 10),
                contactOffset: 0,
                contactLimit: 50
            },
        }),
        props({customerQuery: {fetchMore, customer, variables, ...rest}}) {
            return {
                customerQuery: {
                    customer,
                    variables,
                    ...rest,
                    loadMoreContacts(profile) {
                        return fetchMore({
                            query: ContactList,
                            variables: {
                                profile,
                                type: variables.contactType,
                                offset: customer.profiles.find(p => (p.id === profile)).contacts.length,
                                limit: variables.contactLimit,
                            },
                            updateQuery: (previousResult, {fetchMoreResult}) => {
                                if (!fetchMoreResult.contacts) {
                                    return previousResult;
                                }
                                const profiles = customer.profiles.slice(0);
                                const profileIdx = profiles.findIndex(p => (p.id === profile));
                                const contacts = [...profiles[profileIdx].contacts, ...fetchMoreResult.contacts];
                                profiles[profileIdx] = Object.assign({}, profiles[profileIdx], {contacts});
                                const updatedCustomer = Object.assign({}, previousResult.customer, {profiles});
                                return Object.assign({}, previousResult, {customer: updatedCustomer});
                            }
                        });
                    }
                }
            }
        }
    }),
    graphql(ChangeOnlineMutation, {name: 'changeOnline'}),
    graphql(SetNoteMutation, {name: 'setVoiceNote'}),
    graphql(SendSMSMutation, {name: 'sendSms'}),
    graphql(EditProfileNote, {name: 'editProfileNote'}),
    graphql(CreateProfileNote, {name: 'createProfileNote'}),
    graphql(EditProfileTitle, {name: 'editProfileTitle'}),
    graphql(EditProfileInfo, {name: 'editProfileInfo'}),
    graphql(MarkProfileRead, {name: 'markProfileRead'}),
    graphql(AdvertEditMutation, {name: 'editAdvert'}),
    graphql(AdvertCreateMutation, {name: 'createAdvert'}),
    graphQLErrorProcesor(['operatorQuery', 'contactsQuery', 'customerQuery', 'enumsQuery']),
)(ConversationsProvider);


// WEBPACK FOOTER //
// ./src/containers/Conversations/index.jsx